export default function CTASection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-navy to-navy-dark text-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Webサイトで成果を出したい方へ
        </h2>
        <p className="text-lg md:text-xl mb-10 text-white/90">
          戦略的なWeb制作で、あなたのビジネスを次のステージへ
        </p>
        <div className="text-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="inline-flex items-center gap-2 bg-cta hover:bg-cta-hover text-white px-8 py-4 rounded-lg text-lg font-medium transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            まずはお気軽にご相談ください
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
